import { useMutation, useQueryClient } from "@tanstack/react-query";
import { noteAttachmentsApi } from "@/lib/api/crm";
import { NOTES_KEY } from "@/hooks/useNotes";
import { TIMELINE_KEY } from "@/hooks/useTimeline";
import { DEAL_ACTIVITY_KEY } from "@/hooks/useDealActivity";
import { PROJECT_ACTIVITY_KEY } from "@/hooks/useProjectActivity";
import { toast } from "sonner";

const ACTIVITY_NOTES_KEY = "activity-notes";

export function useUploadAttachments(entityType: string, entityId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ noteId, files }: { noteId: string; files: File[] }) =>
      noteAttachmentsApi.upload(noteId, files),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [NOTES_KEY, entityType, entityId] });
      queryClient.invalidateQueries({ queryKey: [TIMELINE_KEY, entityType, entityId] });
      queryClient.invalidateQueries({ queryKey: [ACTIVITY_NOTES_KEY] });
      queryClient.invalidateQueries({ queryKey: [DEAL_ACTIVITY_KEY] });
      queryClient.invalidateQueries({ queryKey: [PROJECT_ACTIVITY_KEY] });
      toast.success("File uploaded");
    },
    onError: (error: Error) => {
      toast.error(error.message || "Failed to upload file");
    },
  });
}

export function useDeleteAttachment(entityType: string, entityId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ noteId, attachmentId }: { noteId: string; attachmentId: string }) =>
      noteAttachmentsApi.delete(noteId, attachmentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [NOTES_KEY, entityType, entityId] });
      queryClient.invalidateQueries({ queryKey: [TIMELINE_KEY, entityType, entityId] });
      queryClient.invalidateQueries({ queryKey: [ACTIVITY_NOTES_KEY] });
      queryClient.invalidateQueries({ queryKey: [DEAL_ACTIVITY_KEY] });
      queryClient.invalidateQueries({ queryKey: [PROJECT_ACTIVITY_KEY] });
      toast.success("File deleted");
    },
    onError: (error: Error) => {
      toast.error(error.message || "Failed to delete file");
    },
  });
}
